import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { cn } from '@tonic/shared';

const navItems = [
  { label: 'Dashboard', path: '/inventory' },
  { label: 'Items', path: '/inventory/items' },
  { label: 'Transfers', path: '/inventory/transfers' },
  { label: 'Locations', path: '/inventory/locations' },
];

export function InventoryLayout() {
  const location = useLocation();

  return (
    <div className="container mx-auto py-6">
      <nav className="mb-6">
        <ul className="flex gap-4 border-b">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={cn(
                  'inline-block px-4 py-2 text-sm font-medium transition-colors',
                  location.pathname === item.path
                    ? 'border-b-2 border-primary text-primary'
                    : 'text-gray-500 hover:text-gray-900'
                )}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </div>
  );
}

InventoryLayout.propTypes = {}; 
